var render = function render(){var _vm=this,_c=_vm._self._c;return _c('InputComponent',{class:[
    `field-dynamic field-dynamic--theme-${_vm.options.theme}`,
    { 'field-dynamic--no-padding': _vm.$attrs.noPadding },
  ],attrs:{"label":_vm.label,"sublabel":_vm.$attrs.sublabel}},[_c('div',{staticClass:"elder-input__element field-dynamic__items",style:(_vm.style)},_vm._l((_vm.items),function(item,index){return _c('Field',_vm._g({key:index,staticClass:"field-dynamic__item",style:({ '--grid-area': item.key }),attrs:{"value":_vm.get(item.key),"schema":item}},{
        ..._vm.$listeners,
        input: $ev => _vm.onInput($ev, item),
        remove: $ev => _vm.$emit('remove', $ev),
      }))}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }